module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fileList"
  }, [(_vm.deleting && !_vm.working) ? _c('div', {
    staticClass: "deleteDialog"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.i18n().remove.prompt(_vm.deleting)) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "yesno"
  }, [_c('span', {
    staticClass: "btn mdl-button mdl-js-button mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(_vm._s(_vm.i18n().remove.yes))]), _vm._v(" "), _c('span', {
    staticClass: "btn mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.cancelDelete
    }
  }, [_vm._v(_vm._s(_vm.i18n().remove.no))])])]) : _vm._e(), _vm._v(" "), (_vm.fileList && !_vm.deleting && !_vm.working) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.fileList), function(file, index) {
    return _c('div', {
      staticClass: "file",
      class: {
        selected: _vm.selected == file
      },
      on: {
        "click": function($event) {
          _vm.select(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("insert_drive_file")]), _vm._v(" "), (_vm.renaming != file) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(file.name))]) : _vm._e(), _vm._v(" "), (!_vm.renaming && !_vm.deleting) ? _c('span', {
      staticClass: "buttons"
    }, [_c('span', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.remove(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), _c('span', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.rename(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("create")])])]) : _vm._e(), _vm._v(" "), (_vm.renaming == file) ? _c('span', {
      staticClass: "rename"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newName),
        expression: "newName"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newName = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.renaming == file) ? _c('span', {
      staticClass: "buttons"
    }, [_c('span', {
      staticClass: "btn",
      on: {
        "click": _vm.finishRename
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("done")])])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fileList && !_vm.working),
      expression: "!fileList && !working"
    }],
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().loading))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.working),
      expression: "working"
    }],
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d0c9038"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/save/FileList.vue
// module id = 444
// module chunks = 0